//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'

export default {
  name: 'rb-banner-text-below',
  components: {
    RbBanner,
  },
  props: {
    size: {
      type: String,
      default: 'medium', // options: ['large', 'medium', 'small', 'xsmall', 'fixed']
    },
    textAlign: {
      type: String,
      default: 'center', // options: ['left', 'center', 'right']
    },
    pillPosition: {
      type: String,
      default: 'top-left', // options: ['top-left', 'top-center' or 'top', 'top-right', 'left', 'right', 'bottom-left', 'bottom-center' or 'bottom', 'bottom-right']
    },
    controlsMobilePosition: {
      type: String,
      default: 'bottom-center', // options: ['top-left', 'top-center' or 'top', 'top-right', 'left', 'center', 'right', 'bottom-left', 'bottom-center' or 'bottom', 'bottom-right']
    },
    isAnimationEnabled: {
      type: Boolean,
      default: false,
    },
  },
}
